import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
  imageSide: '',
  imageFront: '',
  imageReverse: '',
  fileType: 'jpeg',
  dataOCR: {},
  documentType: '',
  nationality: '',
  wayCaptureDocument: '',
  intentsSearchSign: 0,
  errorOcr: {
    message: '',
    status: null,
    details: '',
    messageFormatted: '',
    action: '',
    showCallAgency: false,
  },
};

const ocr = createSlice({
  name: 'ocr',
  initialState,
  reducers: {
    setDocumentType(state, { payload }) {
      state.documentType = payload;
    },
    setImageSide(state, { payload }) {
      if (state.imageSide === 'clean') {
        state.imageSide = '';
        state.imageFront = '';
        state.imageReverse = '';
        state.fileType = '';
      } else {
        state.imageSide = payload.imageSide;
        state[payload.imageSide] = payload.imageData || '';
        state.fileType = payload.fileType || 'jpeg';
      }
    },
    setDataOCR(state, { payload }) {
      state.dataOCR = payload;
    },
    setNationality(state, { payload }) {
      state.nationality = payload;
    },
    setWayCaptureDocument(state, { payload }) {
      state.wayCaptureDocument = payload;
    },
    setToken(state, { payload }) {
      state.token = payload;
    },
    setIntentsSearchSign(state, { payload }) {
      state.intentsSearchSign = payload;
    },
    setErrorOcr(state, { payload }) {
      state.errorOcr.message = payload.message || '';
      state.errorOcr.status = payload.status || null;
      state.errorOcr.details = payload.details || '';
      state.errorOcr.messageFormatted = payload.messageFormatted || '';
      state.errorOcr.action = payload.action || '';
      state.errorOcr.showCallAgency = payload.showCallAgency || false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_OCR_STATE', (state, { payload }) => {
      // Indica si debe conservar el token
      const keepToken = payload?.keepToken;

      let token = '';
      if (keepToken) {
        token = state.token;
      }

      // resetear el state
      return {
        ...initialState, // Resetea el resto de las propiedades
        token, // Si aplica a asignar el token activo
      };
    });
  },
});

export const {
  setImageSide,
  setDataOCR,
  setDocumentType,
  setNationality,
  setWayCaptureDocument,
  setToken,
  setIntentsSearchSign,
  setErrorOcr,
} = ocr.actions;
export default ocr.reducer;
